import 'react-calendar/dist/Calendar.css';
import './BookingPeriod.css';

import { useState, useMemo, useEffect } from 'react';
import Calendar from 'react-calendar';

import FormLayout from '../ReusableComponents/FormLayout';

import { useStep } from '../Base/StepContext';
import { useTranslation } from 'react-i18next';
import { useGlobal } from '../../Core/GlobalState/Store';

import DateService from '../../Core/Services/DateService';

import SettingsService from '../../Core/Services/SettingsService';

export default function BookingPeriod() {
  const { t } = useTranslation();
  const { handleNext, handlePrev } = useStep();
  const { currentLocation, date, setDate, selectedSize } = useGlobal();

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);
  const today = DateService.getToday();

  const languageCode = SettingsService.getLanguage();

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //Use Memo to only render/ recalculate the bookable days once, as it is used in the calendar tile styling and should not change during the component lifecycle.
  const bookableDays = useMemo(() => DateService.getNextBookableDays(9), []);

  const tileStyle = ({ date }) => {
    const isDisabled = !DateService.isWeekday(date);
    const isBookable = bookableDays.some(d => d.getTime() === date.getTime());

    if (isDisabled) {
      return '!bg-white !text-gray-500';
    }
    if (isBookable) {
      return 'text-booking-available';
    }
    return '';
  };

  const handleBooking = () => {
    if (
      DateService.isWithinDaysFromToday(date, 9) &&
      DateService.isWeekday(date)
    ) {
      handleNext();
    } else {
      const size = selectedSize?.formSize ?? '';
      const container = currentLocation?.page_id ?? '';
      //This url is dynamic and needs to come form the settings.
      const formPage = SettingsService.getFormPage();
      window.location.href = `${window.location.origin}/${formPage}/?size=${size}&type=self_storage&container=${container}`;
    }
  };

  return (
    <FormLayout
      title={'choose_booking_period_title'}
      description={'choose_booking_period_description'}
    >
      <div className="" id="form">
        <div className="w-full md:min-h-[700px] px-4">
          <div className="w-full mx-auto flex flex-col items-center !mb-4 md:max-w-[85%]">
            <Calendar
              locale={languageCode}
              tileClassName={tileStyle}
              onChange={date => {
                const localDate = DateService.toLocalDate(date);
                console.log('Booking date set:', localDate);
                setDate(localDate);
              }}
              showDoubleView={isLargeScreen}
              value={date}
              minDate={today}
              showNeighboringDecades={false}
              showNeighboringCenturys={false}
              className="w-full md:p-6 !border-none"
              next2Label={null}
              prev2Label={null}
              showFixedNumberOfWeeks={false}
              tileDisabled={({ date }) => !DateService.isWeekday(date)}
            />
            <div className="h-2"></div>
            <div className="!mt-2 md:flex justify-between text-center mb-4 self-middle gap-5">
              <div
                style={{ color: '#01A920' }}
                className="font-bold !mt-2 !md:mt-0 flex gap-1 items-center !border-solid !border-gray-400 border-1 px-4 py-2"
              >
                {t('available_for_booking_now')}
              </div>
            </div>
          </div>
          <div className="max-w-[600px] mx-auto flex gap-4 justify-center mt-4">
            <div
              className="px-9 py-5 !border !border-solid border-gray-400 text-xl font-bold text-center cursor-pointer  hover:bg-primaryblue hover:text-white transition-colors duration-300"
              onClick={handlePrev}
            >
              {t('back')}
            </div>
            <div
              className=" px-9 py-5 !border !border-solid bg-primaryblue text-xl font-bold text-center cursor-pointer  text-white !hover:bg-blue-600 transition-colors duration-300"
              onClick={handleBooking}
            >
              {t('go_next')}
            </div>
          </div>
        </div>
      </div>
    </FormLayout>
  );
}
